import React, { useState, useEffect } from "react";
import { Box, Paper, useTheme, useMediaQuery, Fade } from "@mui/material";
import { ChatListView } from "./ChatListView";
import { MessageView } from "./MessageView";
import { useChatContext } from "../contexts/ChatContext";
import { ChatContainerPanelProps } from "../types/chatTypes";

export const ChatContainerPanel: React.FC<ChatContainerPanelProps> = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const { activeSessionId, setActiveSession } = useChatContext();

  const showMessageView = isMobile && !!activeSessionId;

  const handleBackToList = () => {
    setActiveSession(null);
    // showMessageView will automatically become false when activeSessionId is null
  };

  if (isMobile) {
    return (
      <Box
        sx={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
          minHeight: 0,
        }}
      >
        {!showMessageView ? (
          <ChatListView />
        ) : (
          <MessageView
            sessionId={activeSessionId!}
            onBackClick={handleBackToList}
          />
        )}
      </Box>
    );
  }

  return (
    <Box
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
        minHeight: 0,
      }}
    >
      {!activeSessionId ? (
        <ChatListView />
      ) : (
        <MessageView
          sessionId={activeSessionId}
          onBackClick={handleBackToList}
        />
      )}
    </Box>
  );
};
